<!-- rhillane.component.html -->
<app-navbar></app-navbar>

<!-- Hero Section -->
<section class="banner-section" [style.background-image]="'url(' + bannerImageUrl + ')'">
  <div class="container">
    <!-- Left Column -->
    <div class="left-column">
      <h1>Création Site Web  : Agence N°1 en 2025 avec un Retour sur Investissement (ROI) Maximisé </h1>
      
      <p class="subtitle">Création Site Web  : Réussissez En Ligne Avec Rhillane, Votre Partenaire Digital De Confiance.</p>
      
      <div class="feature-list">
        <div class="feature-item">
          <div class="feature-check">✓</div>
          <p>Site web lancé en 30 jours ou moins</p>
        </div>
        <div class="feature-item">
          <div class="feature-check">✓</div>
          <p>30 jours de support technique gratuit après le lancement</p>
        </div>
        <div class="feature-item">
          <div class="feature-check">✓</div>
          <p>30 minutes de formation gratuite</p>
        </div>
      </div>
      
      <div class="platform-ratings">
        <div class="platform-item">
          <div class="platform-logo">
            <i class="fab fa-google" style="font-size: 1.8rem; color: #4285F4;"></i>
          </div>
          <div class="platform-name">Google</div>
          <div class="rating-score">4.9</div>
          <div class="rating-stars">★★★★★</div>
        </div>
        
        <div class="platform-item">
          <div class="platform-logo">
            <div style="width: 30px; height: 30px; background: #f0d000; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: white; font-weight: bold; font-size: 0.9rem;">✓</div>
          </div>
          <div class="platform-name">Provenexpert</div>
          <div class="rating-score">4.5</div>
          <div class="rating-stars">★★★★★</div>
        </div>
        
        <div class="platform-item">
          <div class="platform-logo">
            <div style="width: 30px; height: 30px; background: #ff6347; border-radius: 4px; display: flex; align-items: center; justify-content: center; color: white; font-weight: bold; font-size: 0.9rem;">C</div>
          </div>
          <div class="platform-name">Clutch</div>
          <div class="rating-score">4.6</div>
          <div class="rating-stars">★★★★★</div>
        </div>
        
        <div class="platform-item">
          <div class="platform-logo">
            <div style="width: 30px; height: 30px; background: #000; border-radius: 4px; display: flex; align-items: center; justify-content: center; color: white; font-weight: bold; font-size: 0.75rem;">sl</div>
          </div>
          <div class="platform-name">Sortlist</div>
          <div class="rating-score">4.8</div>
          <div class="rating-stars">★★★★★</div>
        </div>
      </div>
    </div>
    
    <!-- Right Column - SINGLE FORM ONLY -->
    <div class="right-column">
      <div class="form-wrapper">
        <h2>Un projet en tête ? Faites une demande de devis.</h2>
        
        <!-- Form Steps Indicator -->
        <div class="form-steps">
          <div class="step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
            <div class="step-number">1</div>
            <div class="step-label">INFORMATIONS</div>
          </div>
          <div class="step" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
            <div class="step-number">2</div>
            <div class="step-label">SERVICE SOUHAITÉ</div>
          </div>
          <div class="step" [class.active]="currentStep === 3" [class.completed]="currentStep > 3">
            <div class="step-number">3</div>
            <div class="step-label">DÉTAILS</div>
          </div>
        </div>
        
        <!-- Success Message Alert -->
        <div *ngIf="submissionSuccess && !submissionError && !isSubmitting" class="success-alert">
          <div class="success-icon">✓</div>
          <div class="success-message">
            <strong>Demande envoyée avec succès!</strong>
            <br>Nous avons bien reçu votre demande de devis. 
            <br>Notre équipe vous contactera dans les 24 heures.
          </div>
        </div>

        <!-- Error Message Alert -->
        <div *ngIf="submissionError" class="error-alert">
          <div class="error-icon">!</div>
          <div class="error-message">{{ submissionError }}</div>
        </div>
        
        <!-- THE MAIN FORM - ONLY ONE FORM HERE -->
        <form class="contact-form" #contactForm="ngForm" (ngSubmit)="onSubmit()" *ngIf="!submissionSuccess">
          
          <!-- Step 1: Information -->
          <div *ngIf="currentStep === 1" class="form-step">
            <div class="form-row">
              <input 
                type="text" 
                class="form-control" 
                placeholder="Nom et Prénom"
                [(ngModel)]="formData.name"
                name="name"
                #nameField="ngModel"
                required>
              
              <input 
                type="email" 
                class="form-control" 
                placeholder="Email"
                [(ngModel)]="formData.email"
                name="email"
                #emailField="ngModel"
                required
                email>
            </div>
            
            <div class="form-row">
              <input 
                type="text" 
                class="form-control" 
                placeholder="Entreprise"
                [(ngModel)]="formData.company"
                name="company">
              
              <div class="select-wrapper">
                <select 
                  class="form-control"
                  [(ngModel)]="formData.employeeCount"
                  name="employeeCount">
                  <option value="" disabled selected>Nombre d'employés</option>
                  <option value="1-5">1-5 employés</option>
                  <option value="6-20">6-20 employés</option>
                  <option value="21-50">21-50 employés</option>
                  <option value="51+">51+ employés</option>
                </select>
              </div>
            </div>
            
            <div class="phone-row">
              <select class="country-code-select" 
                      name="countryCode" 
                      [(ngModel)]="formData.countryCode">
                <option value="+33">🇫🇷 +33</option>
                <option value="+212">🇲🇦 +212</option>
              </select>
              <input 
                type="tel" 
                class="form-control phone-input" 
                placeholder="Téléphone"
                [(ngModel)]="formData.phone"
                name="phone"
                required>
            </div>
            
            <button type="button" class="suivant-button" (click)="nextStep()" [disabled]="!formData.name || !formData.email || !isValidEmail(formData.email) || !formData.phone">
              Suivant
            </button>
          </div>

          <!-- Step 2: Services -->
          <div *ngIf="currentStep === 2" class="form-step">
            <div class="services-list">
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.webSite" name="webSite">
                <span class="checkmark"></span>
                Création de site web
              </label>
              
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.seo" name="seo">
                <span class="checkmark"></span>
                Référencement SEO
              </label>
              
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.advertising" name="advertising">
                <span class="checkmark"></span>
                Publicité en ligne
              </label>
              
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.socialMedia" name="socialMedia">
                <span class="checkmark"></span>
                Gestion des réseaux sociaux
              </label>
              
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.design" name="design">
                <span class="checkmark"></span>
                Design graphique
              </label>
              
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.photo" name="photo">
                <span class="checkmark"></span>
                Photographie / Vidéographie
              </label>
              
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.copywriting" name="copywriting">
                <span class="checkmark"></span>
                Copywriting
              </label>
              
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.global" name="global">
                <span class="checkmark"></span>
                Accompagnement global
              </label>
              
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.development" name="development">
                <span class="checkmark"></span>
                Développement d'application (web/mobile)
              </label>
            </div>
            
            <div class="select-wrapper budget-select">
              <select 
                class="form-control"
                [(ngModel)]="formData.budget"
                name="budget">
                <option value="" disabled selected>Budget</option>
                <option value="500-1000">500 - 1000 EUR </option>
                <option value="1000-2500">1000 - 2500 EUR</option>
                <option value="2500-5000">2500 - 5000 EUR</option>
                <option value="5000+">5000+ EUR</option>
              </select>
            </div>
            
            <div class="form-navigation">
              <button type="button" class="prev-button" (click)="previousStep()">
                Précédent
              </button>
              <button type="button" class="suivant-button" (click)="nextStep()" [disabled]="!hasSelectedServices()">
                Suivant
              </button>
            </div>
          </div>

          <!-- Step 3: Details -->
          <div *ngIf="currentStep === 3" class="form-step">
            <input 
              type="text" 
              class="form-control" 
              placeholder="Sujet"
              [(ngModel)]="formData.subject"
              name="subject"
              required>
            
            <textarea 
              class="form-control textarea" 
              placeholder="Donnez nous plus de détails sur votre projet"
              [(ngModel)]="formData.details"
              name="details"
              rows="6"></textarea>
            
            <label class="terms-checkbox">
              <input 
                type="checkbox" 
                [(ngModel)]="formData.acceptTerms" 
                name="acceptTerms"
                required>
              <span class="checkmark"></span>
              En cochant cette case, vous acceptez notre <span class="link-text">Politique de Confidentialité</span> et <span class="link-text">Conditions Générales d'Utilisation</span>.
            </label>
            
            <div class="form-navigation">
              <button type="button" class="prev-button" (click)="previousStep()">
                Précédent
              </button>
              <button 
                type="submit" 
                class="suivant-button"
                [disabled]="!formData.acceptTerms || !formData.subject || isSubmitting"
                [class.button-loading]="isSubmitting">
                <span *ngIf="!isSubmitting">Envoyer la demande</span>
                <span *ngIf="isSubmitting" class="loading-spinner">Envoi en cours...</span>
              </button>
            </div>
          </div>
          
        </form>
        
        <!-- Success State - Show after form submission -->
        <div *ngIf="submissionSuccess" class="success-state">
          <div class="success-content">
            <div class="success-icon-large">✓</div>
            <h3>Merci pour votre demande!</h3>
            <p>Nous avons bien reçu votre demande de devis et nous vous contacterons dans les 24 heures.</p>
            <button type="button" class="suivant-button" (click)="resetForm()">
              Nouvelle demande
            </button>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</section>

<!-- New Attractive Section - Add this after the banner-section -->
<section class="features-showcase-section">
  <div class="container">
    
    <!-- Section Header -->
    <div class="section-header">
      <h2>Votre Succès Digital Commence Ici</h2>
      <p class="section-subtitle">Découvrez pourquoi nous sommes le choix #1 des entreprises </p>
      <div class="header-decoration"></div>
    </div>
    
    <!-- Feature 1 - Web Development (Image Right) -->
    <div class="feature-showcase feature-web">
      <div class="feature-content">
        <div class="feature-badge">
          <span class="badge-icon">🚀</span>
          <span class="badge-text">Création Web</span>
        </div>
        <h3>Sites Web Modernes & Performants</h3>
        <p>Transformez votre vision en réalité digitale avec nos sites web sur mesure, conçus pour convertir vos visiteurs en clients.</p>
        
        <div class="feature-highlights">
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Design responsive & moderne</span>
          </div>
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Optimisation SEO avancée</span>
          </div>
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Performance ultra-rapide</span>
          </div>
        </div>
        
        <div class="feature-stats">
          <div class="stat-item">
            <span class="stat-number">98%</span>
            <span class="stat-label">Satisfaction Client</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">30j</span>
            <span class="stat-label">Délai Livraison</span>
          </div>
        </div>
      </div>
      
      <div class="feature-visual">
        <div class="visual-container strategy-visual">
          <div class="floating-card card-2">
            <div class="image-wrapper">
              <img src="assets/images/2.webp" alt="Stratégie Digitale" />
            </div>
            <div class="card-overlay">
              <span class="overlay-text">Stratégie ROI</span>
            </div>
          </div>
          <div class="pulse-effect"></div>
        </div>
      </div>
    </div>
    
    <!-- Feature 2 - Digital Strategy (Image Left) -->
    <div class="feature-showcase feature-strategy">
      

      <div class="feature-visual">
        <div class="visual-container web-visual">
          <div class="floating-card card-1">
            <div class="image-wrapper">
              <img src="assets/images/Untitled-2.png" alt="Site Web Moderne" />
            </div>
            <div class="card-overlay">
              <span class="overlay-text">Design Moderne</span>
            </div>
          </div>
          <div class="glow-effect"></div>
        </div>
      </div>



      
      <div class="feature-content">
        <div class="feature-badge purple">
          <span class="badge-icon">📊</span>
          <span class="badge-text">Stratégie Digital</span>
        </div>
        <h3>Stratégie Digital sur Mesure</h3>
        <p>Maximisez votre ROI avec nos stratégies digitales éprouvées, adaptées spécifiquement au marché .</p>
        
        <div class="feature-highlights">
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Analyse concurrentielle approfondie</span>
          </div>
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Plan d'action personnalisé</span>
          </div>
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Suivi performance en temps réel</span>
          </div>
        </div>
        
        <div class="feature-stats">
          <div class="stat-item">
            <span class="stat-number">250%</span>
            <span class="stat-label">ROI Moyen</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">24/7</span>
            <span class="stat-label">Support</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Feature 3 - Marketing Digital (Image Right) -->
    <div class="feature-showcase feature-marketing">
      <div class="feature-content">
        <div class="feature-badge orange">
          <span class="badge-icon">📈</span>
          <span class="badge-text">Marketing Digital</span>
        </div>
        <h3>Croissance & Visibilité Online</h3>
        <p>Boostez votre présence digitale et générez plus de leads qualifiés avec nos campagnes marketing innovantes.</p>
        
        <div class="feature-highlights">
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Campagnes publicitaires ciblées</span>
          </div>
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Gestion réseaux sociaux pro</span>
          </div>
          <div class="highlight-item">
            <div class="highlight-icon">✓</div>
            <span>Content marketing engageant</span>
          </div>
        </div>
        
        <div class="feature-stats">
          <div class="stat-item">
            <span class="stat-number">+400%</span>
            <span class="stat-label">Leads Générés</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">3.5x</span>
            <span class="stat-label">Conversion Rate</span>
          </div>
        </div>
      </div>
      
      <div class="feature-visual">
        <div class="visual-container marketing-visual">
          <div class="floating-card card-3">
            <div class="image-wrapper">
              <img src="assets/images/1.webp" alt="Marketing Digital" />
            </div>
            <div class="card-overlay">
              <span class="overlay-text">Growth Hacking</span>
            </div>
          </div>
          <div class="sparkle-effect"></div>
        </div>
      </div>
    </div>
    
    <!-- Call to Action -->
    <div class="section-cta">
      <div class="cta-content">
        <h3>Prêt à Transformer Votre Business ?</h3>
        <p>Rejoignez plus de 500+ entreprises qui nous font confiance</p>
        <button class="cta-button-main" routerLink="/devis">
          <span>Démarrer Mon Projet</span>
          <div class="button-arrow">→</div>
        </button>
      </div>
      <div class="cta-decoration">
        <div class="decoration-circle"></div>
        <div class="decoration-dots"></div>
      </div>
    </div>
    
  </div>
</section>


<!-- Google Partner Certification Section -->
<section class="google-partner-section">
  <div class="container">
    <div class="partner-content">
      <div class="content-left">
        <h2>Digital Alchemy – Agence Marketing Digitale <span class="certified">Certifiée</span></h2>
        
        <h3>Des Résultats Concrets, Une Expertise Reconnue</h3>
        
        <p class="intro-text">Ce badge Google ? Ce n'est pas un hasard.</p>
        
        <p class="highlight-text">
          <strong>Digital Alchemy</strong> fait partie des <span class="top-percent">top 3 %</span> d'agences digitales certifiées 
          <span class="google-partner">Google Partner</span>.
        </p>
        
        <p class="question">Pourquoi nous choisir ? Parce qu'on livre du concret :</p>
        
        <ul class="benefits-list">
          <li>Croissance visible de nos clients</li>
          <li>Stratégies digitales taillées sur-mesure</li>
          <li>Résultats mesurables à chaque étape</li>
        </ul>
        
        <p class="closing-text">
          Avec <strong>Digital Alchemy</strong>, vous avez plus qu'une agence : un vrai partenaire de croissance.
        </p>
        
        <button class="cta-button-red" routerLink="/devis">Je Demande Mon Devis Gratuit!</button>      </div>
      
      <div class="content-right">
        <div class="google-badge-container">
          <img src="assets/images/ggl.webp" alt="Google Partner Premier 2025" class="google-badge">
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Case Study Section - Add this to your Angular component HTML -->
<section class="case-study-section">
  <div class="container">
    
    <!-- Section Header -->
    <div class="case-study-header">
      <h2>ÉTUDE DE CAS "SOUFFLE D'INTÉRIEUR" : BOOSTEZ VOS VENTES EN LIGNE AVEC UN SITE E-COMMERCE </h2>
    </div>
    
    <!-- Case Study Content -->
    <div class="case-study-content">
      
      <!-- Feature 1 - Design E-commerce -->
      <div class="case-study-block">
        <div class="case-study-visual">
          <div class="case-visual-container with-sparkle">
            <img src="assets/images/case1.webp" alt="Design E-commerce Souffle d'Intérieur" class="case-image">
            <div class="floating-elements">
              <div class="float-icon design">🎨</div>
              <div class="float-icon mobile">📱</div>
              <div class="float-icon heart">❤️</div>
            </div>
          </div>
        </div>
        
        <div class="case-study-text">
          <div class="case-badge">
            <span class="badge-icon">🎨</span>
            <span class="badge-text">Design E-commerce Professionnel</span>
          </div>
          
          <h3>Un look pro qui inspire confiance. Une navigation fluide qui vend.</h3>
          
          <p>Votre site doit donner envie d'acheter dès la première seconde. On crée pour vous un <strong>design pro</strong> qui inspire confiance et une <strong>navigation simple</strong> qui pousse à l'action. Sur mobile ou ordinateur, vos clients vivent une <strong>expérience fluide</strong> – et vous vous vendez plus.</p>
          
          <ul class="case-highlights">
            <li><strong>Design e-commerce personnalisé</strong> : votre site reflète votre <strong>identité de marque</strong> et vous démarque.</li>
            <li><strong>Expérience utilisateur (UX) claire</strong> : chaque clic guide vers l'achat.</li>
            <li><strong>Site responsive</strong> : 100 % adapté mobile, tablette et ordinateur.</li>
            <li><strong>Parcours client optimisé</strong> : plus de fluidité, plus de <strong>conversions</strong>.</li>
          </ul>
        </div>
      </div>
      
      <!-- Feature 2 - Fonctionnalités E-commerce -->
      <div class="case-study-block">
        <div class="case-study-text">
          <div class="case-badge blue">
            <span class="badge-icon">⚙️</span>
            <span class="badge-text">Fonctionnalités E-commerce & Performance Optimisée</span>
          </div>
          
          <h3>Un site rapide, fiable et facile à gérer.</h3>
          
          <p>Vos clients veulent acheter sans attendre ni se compliquer la vie. On vous livre un <strong>site rapide, sécurisé</strong> et pensé pour simplifier chaque étape. Et vous, vous gardez le contrôle avec une <strong>gestion facile</strong>, même sans connaissances techniques.</p>
          
          <ul class="case-highlights">
            <li><strong>Chargement rapide</strong> : votre boutique s'ouvre en quelques secondes.</li>
            <li><strong>Paiements sécurisés</strong> : intégration simple de CMI, PayPal, Stripe, etc.</li>
            <li><strong>Interface facile à utiliser</strong> : vous gérez produits et commandes sans prise de tête.</li>
            <li><strong>Fonctionnalités sur mesure</strong> : click & collect, promos, filtres, livraison...</li>
          </ul>
        </div>
        
        <div class="case-study-visual">
          <div class="case-visual-container with-glow">
            <img src="assets/images/case2.webp" alt="Fonctionnalités E-commerce" class="case-image">
            <div class="floating-elements">
              <div class="float-icon cart">🛒</div>
              <div class="float-icon secure">🔒</div>
              <div class="float-icon speed">⚡</div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Feature 3 - SEO & Marketing -->
      <div class="case-study-block">
        <div class="case-study-visual">
          <div class="case-visual-container with-bounce">
            <img src="assets/images/case3.webp" alt="SEO et Marketing" class="case-image">
            <div class="floating-elements">
              <div class="float-icon seo">🔍</div>
              <div class="float-icon analytics">📊</div>
              <div class="float-icon target">🎯</div>
            </div>
          </div>
        </div>
        
        <div class="case-study-text">
          <div class="case-badge green">
            <span class="badge-icon">📈</span>
            <span class="badge-text">Structure SEO & Intégration Marketing</span>
          </div>
          
          <h3>Soyez visible là où vos clients vous cherchent.</h3>
          
          <p>Un site invisible ne vend pas. Nous construisons votre boutique avec une <strong>base SEO solide</strong> et des contenus prêts à performer dès le départ. Résultat : vous <strong>gagnez du trafic gratuit</strong> et touchez vos clients là où ils sont vraiment.</p>
          
          <ul class="case-highlights">
            <li><strong>Site optimisé pour le SEO</strong> : balises, structure et mots-clés dès le départ.</li>
            <li><strong>Contenu e-commerce stratégique</strong> : pages et produits optimisés pour Google.</li>
            <li><strong>Connexion réseaux sociaux</strong> : partage facile, plus de visibilité.</li>
            <li><strong>Suivi intégré</strong> : Google Analytics, Meta Pixel, Search Console – pour mesurer, ajuster, et mieux vendre.</li>
          </ul>
        </div>
      </div>
      
      <!-- Feature 4 - Support & Evolution -->
      <div class="case-study-block">
        <div class="case-study-text">
          <div class="case-badge purple">
            <span class="badge-icon">🛠️</span>
            <span class="badge-text">Support Technique & Évolutivité E-commerce</span>
          </div>
          
          <h3>On reste à vos côtés, votre site grandit avec vous.</h3>
          
          <p>Vous n'êtes jamais seul. Notre équipe reste dispo avant, pendant et après le lancement. On vous forme, on vous assiste, et on fait évoluer votre boutique avec votre business. <strong>Votre succès, c'est aussi le nôtre.</strong></p>
          
          <ul class="case-highlights">
            <li><strong>Support local réactif</strong> : on répond vite, en français ou darija.</li>
            <li><strong>Mises à jour régulières</strong> : sécurité et performance garanties.</li>
            <li><strong>Formation incluse</strong> : vous êtes autonome dès le lancement.</li>
            <li><strong>Site évolutif</strong> : on ajoute des fonctions selon vos besoins.</li>
            <li><strong>Suivi après mise en ligne</strong> : on vérifie les performances et vous aide à ajuster si besoin.</li>
          </ul>
        </div>
        
        <div class="case-study-visual">
          <div class="case-visual-container with-pulse">
            <img src="assets/images/case4.webp" alt="Support et Évolution" class="case-image">
            <div class="floating-elements">
              <div class="float-icon support">📞</div>
              <div class="float-icon update">🔄</div>
              <div class="float-icon growth">📈</div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    
  </div>
</section>


<!-- Add this to your rhillane.component.html file -->
<section class="digital-excellence-section">
  <div class="container">
    
    <!-- Section Content -->
    <div class="excellence-content">
      
      <!-- Left Content -->
      <div class="content-left">
        <div class="section-badge">
          <span class="badge-icon">🚀</span>
          <span class="badge-text">Excellence Digitale</span>
        </div>
        
        <h2>VOTRE PARTENAIRE POUR UN SUCCÈS NUMÉRIQUE</h2>
        
        <p class="intro-text">Découvrez l'excellence en création web avec Rhillane marketing digital :</p>
        
        <div class="benefits-grid">
          <div class="benefit-item">
            <div class="benefit-icon">✓</div>
            <span>Expertise technique et créative</span>
          </div>
          <div class="benefit-item">
            <div class="benefit-icon">✓</div>
            <span>Approche personnalisée</span>
          </div>
          <div class="benefit-item">
            <div class="benefit-icon">✓</div>
            <span>Utilisation des dernières technologies</span>
          </div>
          <div class="benefit-item">
            <div class="benefit-icon">✓</div>
            <span>Résultats mesurables</span>
          </div>
        </div>
        
        <button class="cta-button-primary" routerLink="/devis">
          <span>Demandez votre Devis</span>
          <div class="button-arrow">→</div>
        </button>
      </div>
      
      <!-- Right Visual -->
      <div class="content-right">
        <div class="visual-container">
          <div class="floating-image">
            <img src="assets/images/creation.webp" alt="Digital Excellence" />
          </div>
          
          <!-- Floating Elements -->
          <div class="floating-elements">
            <div class="float-badge badge-1">
              <span class="badge-number">98%</span>
              <span class="badge-label">Satisfaction</span>
            </div>
            <div class="float-badge badge-2">
              <span class="badge-number">500+</span>
              <span class="badge-label">Projets</span>
            </div>
            <div class="float-badge badge-3">
              <span class="badge-number">24/7</span>
              <span class="badge-label">Support</span>
            </div>
          </div>
          
          <!-- Background Effects -->
          <div class="bg-effects">
            <div class="circle-effect circle-1"></div>
            <div class="circle-effect circle-2"></div>
            <div class="circle-effect circle-3"></div>
          </div>
        </div>
      </div>
      
    </div>
    
    <!-- Guarantee Section -->
    <div class="guarantee-section">
      <h3>GARANTIE 30/30/30</h3>
      <p class="guarantee-text">Chaque site web que nous concevons est couvert par notre engagement 30/30/30 :</p>
      
      <div class="guarantee-grid">
        <div class="guarantee-item">
          <div class="guarantee-icon">
            <span>🚀</span>
          </div>
          <h4>Site web lancé en <strong>30 jours</strong> ou moins</h4>
        </div>
        
        <div class="guarantee-item">
          <div class="guarantee-icon">
            <span>🛠️</span>
          </div>
          <h4><strong>30 jours</strong> de support technique gratuit après le lancement</h4>
        </div>
        
        <div class="guarantee-item">
          <div class="guarantee-icon">
            <span>🎓</span>
          </div>
          <h4><strong>30 minutes</strong> de formation gratuite</h4>
        </div>
      </div>
    </div>
    
  </div>
</section>


<!-- Add this new section to your rhillane.component.html file -->
<section class="statistics-section">
  <div class="container">
    
    <!-- Statistics Grid -->
    <div class="stats-grid">
      
      <!-- Stat 1 - Garantie 30/30/30 (wide, top left) -->
      <div class="stat-card guarantee-card">
        <div class="stat-header">
          <span class="stat-category">LANCEMENT, SOUTIEN, HÉBERGEMENT</span>
        </div>
        <h3 class="stat-title">La garantie 30/30/30</h3>
        <p class="stat-description">Engagement de qualité et de rapidité.</p>
      </div>
      
      <!-- Stat 2 - ROI (top middle) -->
      <div class="stat-card">
        <div class="stat-header">
          <span class="stat-category">RÉVOLUTIONNEZ VOTRE ROI</span>
        </div>
        <div class="stat-number">+3800%</div>
        <p class="stat-description">Des résultats mesurables et significatifs.</p>
      </div>
      
      <!-- Stat 3 - CTR (top right) -->
      <div class="stat-card">
        <div class="stat-header">
          <span class="stat-category">BOOSTEZ VOTRE CTR</span>
        </div>
        <div class="stat-number">+350%</div>
        <p class="stat-description">Grâce à notre contenu inventif et à un référencement SEO optimisé.</p>
      </div>
      
      <!-- Stat 4 - Impact (bottom left) -->
      <div class="stat-card">
        <div class="stat-number">+300%</div>
        <p class="stat-description">D'impact pour le même prix</p>
      </div>
      
      <!-- Stat 5 - Response Time (bottom middle) -->
      <div class="stat-card">
        <div class="stat-number large-number">24h</div>
        <div class="stat-label">Chrono</div>
        <p class="stat-description">Réponse en moins de 24 heures.</p>
      </div>
      
      <!-- Stat 6 - UX Optimization (wide, bottom right) -->
      <div class="stat-card ux-card chrono-card">
        <div class="stat-header">
          <span class="stat-category">OPTIMISATION DE L'UX</span>
        </div>
        <div class="stat-number">+40%</div>
        <p class="stat-description">Augmentation du taux de conversion.</p>
      </div>
      
    </div>
    
   
    
  </div>
</section>


<div class="portfolio-modal" [class.active]="selectedPortfolio" *ngIf="selectedPortfolio">
  <div class="modal-backdrop" (click)="closePortfolioModal()"></div>
  <div class="modal-content">
    <button class="modal-close" (click)="closePortfolioModal()">×</button>
    <div class="modal-body">
      <div class="modal-content-wrapper">
        <!-- Left Side: Preview (WebP Image) -->
        <div class="modal-preview-left">
          <!-- Image Preview Container (WebP) -->
          <div class="image-preview-container">
            <img [src]="getWebpImageUrl(selectedPortfolio)" [alt]="selectedPortfolio.title" 
                 class="preview-image" 
                 [class.scale-preview]="!hasMainImage(selectedPortfolio)"
                 (error)="handleImageError($event, selectedPortfolio)">
          </div>
        </div>

        <!-- Right Side: Description/Info -->
        <div class="modal-info-right">
          <div class="modal-header">
            <h3>{{ selectedPortfolio.title }}</h3>
          </div>
          <p class="modal-description">{{ selectedPortfolio.fullDescription || selectedPortfolio.description }}</p>
          <div class="modal-tech">
            <span *ngFor="let tech of selectedPortfolio.technologies" class="tech-tag">{{ tech }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add this new pricing section to your rhillane.component.html file -->
<section class="pricing-section">
  <div class="container">
    
    <!-- Section Header -->
    <div class="pricing-header">
      <h2>Offres sur mesure à prix attractifs pour votre site internet !</h2>
      <p class="pricing-subtitle">Choisissez l'offre qui correspond le mieux à vos besoins et objectifs</p>
    </div>
    
    <!-- Pricing Cards -->
    <div class="pricing-grid">
      
      <!-- Starter Plan -->
      <div class="pricing-card">
        <div class="card-header">
          <h3 class="plan-name">STARTER</h3>
          <p class="plan-subtitle">Idéal pour les nouvelles entreprises</p>
          <div class="plan-badge starter-badge">+30 minutes de formation gratuite</div>
        </div>
        
        <div class="card-pricing">
          <div class="value-badge">
            <span class="value-icon">🚀</span>
            <span class="value-text">Lancement Express</span>
          </div>
          <div class="delivery-time">Livraison en 15 jours</div>
        </div>
        
        <div class="card-features">
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>1 page professionnelle</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Design Responsive</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Expérience utilisateur UX</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Formulaire de contact</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Gestion de contenu simplifiée</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Galerie captivante</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Intégration vidéo</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Accompagnement domaine/hébergement</span>
          </div>
          <div class="feature-item highlight">
            <span class="check-icon">✓</span>
            <span>Support 30 jours gratuit</span>
          </div>
        </div>
        
        <button class="cta-button starter-button" routerLink="/devis">
          <span>Obtenir un Devis Gratuit</span>
        </button>
      </div>
      
      <!-- Pro Plan (Most Popular) -->
      <div class="pricing-card pro-card">
        <div class="popular-badge">LE PLUS POPULAIRE</div>
        
        <div class="card-header">
          <h3 class="plan-name">PRO</h3>
          <p class="plan-subtitle">Une solution idéale pour les entreprises en croissance</p>
          <div class="plan-badge pro-badge">+30 minutes de formation gratuite</div>
        </div>
        
     
        
        <div class="card-features">
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>5 pages professionnelles</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Design Responsive Premium</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Expérience utilisateur UX avancée</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Formulaires personnalisés</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>CMS complet et intuitif</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Galerie photo/vidéo dynamique</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Optimisation SEO de base</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Intégration Google Analytics</span>
          </div>
          <div class="feature-item highlight">
            <span class="check-icon">✓</span>
            <span>Support prioritaire 60 jours</span>
          </div>
        </div>
        
        <button class="cta-button pro-button" routerLink="/devis">
          <span>Obtenir un Devis Gratuit</span>
        </button>
      </div>
      
      <!-- Flex Plan -->
      <div class="pricing-card">
        <div class="card-header">
          <h3 class="plan-name">FLEX</h3>
          <p class="plan-subtitle">La solution complète pour les entreprises établies</p>
          <div class="plan-badge flex-badge">+30 minutes de formation gratuite</div>
        </div>
        
        <div class="card-pricing">
          <div class="value-badge flex-value">
            <span class="value-icon">👑</span>
            <span class="value-text">Solution Complète</span>
          </div>
          <div class="delivery-time">Livraison en 30 jours</div>
        </div>
        
        <div class="card-features">
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>5 pages + sections illimitées</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Conception d'un logo professionnel</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Charte graphique complète</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Design Responsive Ultra Premium</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>UX/UI Design professionnel</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Fonctionnalités sur mesure</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>SEO avancé + stratégie contenu</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Analytics + Tracking complet</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Intégrations tierces illimitées</span>
          </div>
          <div class="feature-item highlight">
            <span class="check-icon">✓</span>
            <span>Support VIP 90 jours + maintenance</span>
          </div>
        </div>
        
        <button class="cta-button flex-button" routerLink="/devis">
          <span>Obtenir un Devis Gratuit</span>
        </button>
      </div>
      
    </div>
    
  
  </div>
</section>


<section id="portfolio" class="portfolio-showcase-section">
  <div class="container">
    
    <!-- Section Header -->
    <div class="portfolio-header">
      <h2>Découvrez Notre Galerie de Projets Exceptionnels</h2>
      <p class="portfolio-subtitle">
        Explorez nos réalisations et laissez-vous inspirer par notre savoir-faire. 
        Nous transformons les idées en expériences numériques innovantes et impactantes.
      </p>
    </div>
    
    <!-- Portfolio Filter Tabs -->
    <div class="portfolio-filters">
      <button 
        *ngFor="let filter of portfolioFilters" 
        [class.active]="activeFilter === filter.value"
        (click)="setActiveFilter(filter.value)"
        class="filter-btn">
        {{ filter.label }}
      </button>
    </div>
    
    <!-- Portfolio Grid -->
    <div class="portfolio-grid">
      <div 
        *ngFor="let item of getFilteredPortfolio(); let i = index" 
        class="portfolio-item"
        [style.animation-delay]="i * 0.1 + 's'"
        (click)="openPortfolioModal(item)">
        
        <div class="portfolio-card">
          <div class="portfolio-image-wrapper">
            <img [src]="item.image && item.image.startsWith('portfolio/') ? getPreviewImageUrl(item) : ('assets/images/' + item.image)" [alt]="item.title" class="portfolio-image">
            <div class="portfolio-overlay">
              <div class="portfolio-overlay-content">
                <h3 class="portfolio-title">{{ item.title }}</h3>
                <p class="portfolio-category">{{ item.category }}</p>
              </div>
            </div>
          </div>
          
          <!-- Portfolio Info -->
          <div class="portfolio-info">
            <h4 class="portfolio-name">{{ item.title }}</h4>
            <p class="portfolio-brief">{{ item.brief }}</p>
          
          </div>
        </div>
      </div>
    </div>
    
    <!-- Load More Button -->
    <div class="portfolio-cta" *ngIf="hasMoreProjects">
      <button class="load-more-btn" (click)="loadMoreProjects()">
        <span>Voir Plus de Projets</span>
        <div class="btn-arrow">↓</div>
      </button>
    </div>
    
  </div>
</section>


<!-- Add this new services section to your rhillane.component.html file -->
<section class="services-showcase-section">
  <div class="container">
    
    <!-- Services Grid -->
    <div class="services-grid">
      
      <!-- Site Web Personnalisé (Top Left) -->
      <div class="service-card teal-card">
        <h3 class="service-title">SITE WEB PERSONNALISÉ</h3>
        <div class="service-features">
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Conception sur mesure jusqu'à 5 pages</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>10 Images GRATUITES</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Intégration réseaux sociaux</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Inclusion de Google Maps</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Formulaires de contact interactifs</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Design responsive adapté aux mobiles</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Équipe de trois développeurs expérimentés</span>
          </div>
        </div>
      </div>
      
      <!-- Logo Design (Top Right) -->
      <div class="service-card blue-card">
        <h3 class="service-title">LOGO DESIGN</h3>
        <div class="service-features">
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>3 propositions de logo uniques</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>2 séances de révisions incluses</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Équipe de cinq designers spécialisés</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Création de logo et icône de marque</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Animation du logo</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Guides d'utilisation du logo</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Fichiers livrables (AI, PDF, SVG, EPS, PNG)</span>
          </div>
        </div>
      </div>
      
      <!-- Central Branding Solution -->
      <div class="central-branding">
        <div class="branding-content">
          <div class="brand-decorations">
            <div class="decoration-line left-line"></div>
            <div class="decoration-line right-line"></div>
          </div>
          
          <h2 class="branding-title">
            SOLUTION<br>
            COMPLÈTE DE<br>
            <span class="highlight">BRANDING</span>
          </h2>
          
          <p class="branding-subtitle">(ALL IN ONE)</p>
          
          <div class="branding-image">
            <img src="assets/images/aa.webp" alt="Branding Solution" />
          </div>
          
          <button class="branding-cta" routerLink="/devis">
            <span>Demandez votre devis</span>
          </button>
        </div>
      </div>
      
      <!-- Optimisation SEO (Bottom Left) -->
      <div class="service-card red-card">
        <h3 class="service-title">OPTIMISATION SEO</h3>
        <div class="service-features">
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Analyse et optimisation de mots-clés</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Optimisation on-page</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Techniques SEO avancées</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Contenu web enrichi et ciblé</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>SEO local</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Stratégies de backlinking</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Rapports détaillés d'analyse SEO</span>
          </div>
        </div>
      </div>
      
      <!-- Avantages (Bottom Right) -->
      <div class="service-card pink-card">
        <h3 class="service-title">AVANTAGES</h3>
        <div class="service-features">
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Directeur artistique dédié à chaque projet</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Droits de propriété exclusifs</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Engagement de satisfaction totale</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Garantie de conception 100% unique</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Support disponible 24/7</span>
          </div>
          <div class="feature-item">
            <span class="check-icon">✓</span>
            <span>Service après-vente exemplaire</span>
          </div>
        </div>
      </div>
      
    </div>
    
  </div>
</section>




<!-- Add this new FAQ section to your rhillane.component.html file -->
<section class="faq-partners-section">
  <div class="container">
    
    <!-- FAQ Content -->
    <div class="faq-content">
      
      <!-- Left Column - FAQ -->
      <div class="faq-left">
        <h2>FAQ: Tout Savoir sur la Création Web  </h2>
        
        <div class="faq-list">
          <!-- FAQ Item 1 -->
          <div class="faq-item" [class.active]="activeFaq === 1">
            <div class="faq-question" (click)="toggleFaq(1)">
              <span>Quel est le coût de la création d'un site internet ?</span>
              <div class="faq-arrow">
                <i class="arrow-icon" [class.rotated]="activeFaq === 1">▼</i>
              </div>
            </div>
            <div class="faq-answer" [class.show]="activeFaq === 1">
              <div class="answer-content">
                <p>Le coût de la création d'un site internet dépend de plusieurs facteurs, notamment le type de site, les fonctionnalités souhaitées, et la complexité du projet.</p>
                <p>Chez notre agence de création de sites web , nous offrons des <strong>solutions adaptées à tous les budgets</strong>, de la création de sites vitrines simples à des projets web plus complexes.</p>
              </div>
            </div>
          </div>
          
          <!-- FAQ Item 2 -->
          <div class="faq-item" [class.active]="activeFaq === 2">
            <div class="faq-question" (click)="toggleFaq(2)">
              <span>Quel est le prix d'un site vitrine ?</span>
              <div class="faq-arrow">
                <i class="arrow-icon" [class.rotated]="activeFaq === 2">▼</i>
              </div>
            </div>
            <div class="faq-answer" [class.show]="activeFaq === 2">
              <div class="answer-content">
                <p>Un site vitrine professionnel   chez Digital Alchemy. Ce tarif inclut un design responsive, l'optimisation SEO de base, et un accompagnement personnalisé.</p>
              </div>
            </div>
          </div>
          
          <!-- FAQ Item 3 -->
          <div class="faq-item" [class.active]="activeFaq === 3">
            <div class="faq-question" (click)="toggleFaq(3)">
              <span>Quels types de sites web proposez-vous ?</span>
              <div class="faq-arrow">
                <i class="arrow-icon" [class.rotated]="activeFaq === 3">▼</i>
              </div>
            </div>
            <div class="faq-answer" [class.show]="activeFaq === 3">
              <div class="answer-content">
                <p>Nous proposons une gamme complète de sites web : sites vitrines, boutiques e-commerce, sites corporate, portfolios, blogs, et applications web sur mesure adaptés à vos besoins spécifiques.</p>
              </div>
            </div>
          </div>
          
          <!-- Additional FAQ Items (hidden by default) -->
          <div class="additional-faqs" [class.show]="showAllFaqs">
            
            <!-- FAQ Item 4 -->
            <div class="faq-item" [class.active]="activeFaq === 4">
              <div class="faq-question" (click)="toggleFaq(4)">
                <span>Quels sont les avantages d'un site internet responsive ?</span>
                <div class="faq-arrow">
                  <i class="arrow-icon" [class.rotated]="activeFaq === 4">▼</i>
                </div>
              </div>
              <div class="faq-answer" [class.show]="activeFaq === 4">
                <div class="answer-content">
                  <p>Un site responsive s'adapte automatiquement à tous les écrans (mobile, tablette, desktop), améliore l'expérience utilisateur, et est favorisé par Google pour le référencement naturel.</p>
                </div>
              </div>
            </div>
            
            <!-- FAQ Item 5 -->
            <div class="faq-item" [class.active]="activeFaq === 5">
              <div class="faq-question" (click)="toggleFaq(5)">
                <span>Comment puis-je obtenir un nom de domaine pour mon site web ?</span>
                <div class="faq-arrow">
                  <i class="arrow-icon" [class.rotated]="activeFaq === 5">▼</i>
                </div>
              </div>
              <div class="faq-answer" [class.show]="activeFaq === 5">
                <div class="answer-content">
                  <p>Nous vous accompagnons dans le choix et l'enregistrement de votre nom de domaine. Notre équipe vous conseille sur les meilleures extensions (.ma, .com, .fr) selon votre activité.</p>
                </div>
              </div>
            </div>
            
            <!-- FAQ Item 6 -->
            <div class="faq-item" [class.active]="activeFaq === 6">
              <div class="faq-question" (click)="toggleFaq(6)">
                <span>Votre agence digitale offre-t-elle des services de développement web sur mesure ?</span>
                <div class="faq-arrow">
                  <i class="arrow-icon" [class.rotated]="activeFaq === 6">▼</i>
                </div>
              </div>
              <div class="faq-answer" [class.show]="activeFaq === 6">
                <div class="answer-content">
                  <p>Oui, Digital Alchemy développe des solutions web sur mesure adaptées à vos besoins spécifiques : applications métier, plateformes e-commerce avancées, et systèmes de gestion personnalisés.</p>
                </div>
              </div>
            </div>
            
            <!-- FAQ Item 7 -->
            <div class="faq-item" [class.active]="activeFaq === 7">
              <div class="faq-question" (click)="toggleFaq(7)">
                <span>Comment puis-je maximiser la visibilité de mon site web ?</span>
                <div class="faq-arrow">
                  <i class="arrow-icon" [class.rotated]="activeFaq === 7">▼</i>
                </div>
              </div>
              <div class="faq-answer" [class.show]="activeFaq === 7">
                <div class="answer-content">
                  <p>Nous optimisons votre site pour le SEO local, créons du contenu de qualité, mettons en place des campagnes Google Ads ciblées, et développons votre présence sur les réseaux sociaux.</p>
                </div>
              </div>
            </div>
            
            <!-- FAQ Item 8 -->
            <div class="faq-item" [class.active]="activeFaq === 8">
              <div class="faq-question" (click)="toggleFaq(8)">
                <span>Pourquoi Choisir Notre Expertise en Création Site Web  ?</span>
                <div class="faq-arrow">
                  <i class="arrow-icon" [class.rotated]="activeFaq === 8">▼</i>
                </div>
              </div>
              <div class="faq-answer" [class.show]="activeFaq === 8">
                <div class="answer-content">
                  <p>Digital Alchemy combine expertise technique, créativité, et connaissance du marché . Nous offrons un support 24/7, des prix compétitifs, et une garantie de satisfaction totale.</p>
                </div>
              </div>
            </div>
            
            <!-- FAQ Item 9 -->
            <div class="faq-item" [class.active]="activeFaq === 9">
              <div class="faq-question" (click)="toggleFaq(9)">
                <span>Quels sont les types de sites proposés en création site web  ?</span>
                <div class="faq-arrow">
                  <i class="arrow-icon" [class.rotated]="activeFaq === 9">▼</i>
                </div>
              </div>
              <div class="faq-answer" [class.show]="activeFaq === 9">
                <div class="answer-content">
                  <p>Nous créons tous types de sites : vitrines professionnels, e-commerce, blogs, portfolios, sites institutionnels, plateformes de réservation, et applications web métier.</p>
                </div>
              </div>
            </div>
            
          </div>
        </div>
        
        <!-- Toggle Button -->
        <div class="faq-toggle">
          <button class="toggle-btn" (click)="toggleAllFaqs()">
            <span>{{ showAllFaqs ? 'Réduire' : 'Afficher plus' }}</span>
            <i class="toggle-arrow" [class.rotated]="showAllFaqs">▼</i>
          </button>
        </div>
        
        <!-- Sliding Client Logos -->
        <div class="clients-slider">
          <div class="slider-track">
            <div class="client-logo">
              <img src="assets/images/cc/Mariner-primary-logo-white-h.webp" alt="Client Logo" />
            </div>
            <div class="client-logo">
              <img src="assets/images/cc/display-stream.svg" alt="Display Stream Logo" />
            </div>
            <div class="client-logo">
              <img src="assets/images/cc/IEF-e1707300382671.webp" alt="IEF Logo" />
            </div>
            <div class="client-logo">
              <img src="assets/images/cc/Logo-OVH.webp" alt="OVH Logo" />
            </div>
            <div class="client-logo">
              <img src="assets/images/cc/Mariner-primary-logo-white-h.webp" alt="Mariner Logo" />
            </div>
            <div class="client-logo">
              <img src="assets/images/cc/mididis-e1707300418200.webp" alt="Mididis Logo" />
            </div>
            <div class="client-logo">
              <img src="assets/images/cc/display-stream.svg" alt="Client Logo" />
            </div>
            <div class="client-logo">
              <img src="assets/images/clients/2-light.png" alt="Client Logo" />
            </div>
            <div class="client-logo">
              <img src="assets/images/cc/Marinier-primary-logo-white-h.webp" alt="Client Logo" />
            </div>
          </div>
        </div>
      </div>
      
      <!-- Right Column - Form with Email Integration -->
      <div class="faq-right">
        <div class="form-wrapper">
          <h3>Transformez Votre Présence en Ligne avec la Création Web </h3>
          
          <p class="form-description">
            Prenez une longueur d'avance sur vos concurrents avec une 
            <strong>création web </strong> sur mesure. Notre équipe d'experts 
            crée des sites web optimisés pour le SEO, adaptés aux besoins 
            spécifiques de votre marché local. Contactez-nous aujourd'hui 
            pour découvrir comment nous pouvons améliorer votre 
            visibilité en ligne !
          </p>
          
          <!-- Form Steps -->
          <div class="form-steps">
            <div class="step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
              <div class="step-number">1</div>
              <div class="step-label">INFORMATIONS</div>
            </div>
            <div class="step" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
              <div class="step-number">2</div>
              <div class="step-label">SERVICE SOUHAITÉ</div>
            </div>
            <div class="step" [class.active]="currentStep === 3" [class.completed]="currentStep > 3">
              <div class="step-number">3</div>
              <div class="step-label">DÉTAILS</div>
            </div>
          </div>
          
          <!-- Success Message Alert -->
          <div *ngIf="submissionSuccess && !submissionError && !isSubmitting" class="success-alert">
            <div class="success-icon">✓</div>
            <div class="success-message">
              <strong>Demande envoyée avec succès!</strong>
              <br>Nous avons bien reçu votre demande de devis. 
              <br>Notre équipe vous contactera dans les 24 heures.
            </div>
          </div>

          <!-- Error Message Alert -->
          <div *ngIf="submissionError" class="error-alert">
            <div class="error-icon">!</div>
            <div class="error-message">{{ submissionError }}</div>
          </div>
          
          <!-- Contact Form with Email Integration -->
          <form class="contact-form" #faqContactForm="ngForm" (ngSubmit)="onSubmit()" *ngIf="!submissionSuccess">
            
            <!-- Step 1: Information -->
            <div *ngIf="currentStep === 1" class="form-step">
              <div class="form-row">
                <input 
                  type="text" 
                  class="form-control" 
                  placeholder="Nom et Prénom"
                  [(ngModel)]="formData.name"
                  name="name"
                  #nameField="ngModel"
                  required>
                
                <input 
                  type="email" 
                  class="form-control" 
                  placeholder="Email"
                  [(ngModel)]="formData.email"
                  name="email"
                  #emailField="ngModel"
                  required
                  email>
              </div>
              
              <div class="form-row">
                <input 
                  type="text" 
                  class="form-control" 
                  placeholder="Entreprise"
                  [(ngModel)]="formData.company"
                  name="company">
                
                <div class="select-wrapper">
                  <select 
                    class="form-control"
                    [(ngModel)]="formData.employeeCount"
                    name="employeeCount">
                    <option value="" disabled selected>Nombre d'employés</option>
                    <option value="1-5">1-5 employés</option>
                    <option value="6-20">6-20 employés</option>
                    <option value="21-50">21-50 employés</option>
                    <option value="51+">51+ employés</option>
                  </select>
                </div>
              </div>
              
              <div class="phone-row">
                <select class="country-code-select" 
                        name="countryCode2" 
                        [(ngModel)]="formData.countryCode">
                  <option value="+33">🇫🇷 +33</option>
                  <option value="+212">🇲🇦 +212</option>
                </select>
                <input 
                  type="tel" 
                  class="form-control phone-input" 
                  placeholder="Téléphone"
                  [(ngModel)]="formData.phone"
                  name="phone2"
                  required>
              </div>
              
              <button 
                type="button" 
                class="suivant-button" 
                (click)="nextStep()" 
                [disabled]="!formData.name || !formData.email || !isValidEmail(formData.email) || !formData.phone">
                Suivant
              </button>
            </div>

            <!-- Step 2: Services -->
            <div *ngIf="currentStep === 2" class="form-step">
              <div class="services-list">
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.webSite" name="webSite">
                  <span class="checkmark"></span>
                  Création de site web
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.seo" name="seo">
                  <span class="checkmark"></span>
                  Référencement SEO
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.advertising" name="advertising">
                  <span class="checkmark"></span>
                  Publicité en ligne
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.socialMedia" name="socialMedia">
                  <span class="checkmark"></span>
                  Gestion des réseaux sociaux
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.design" name="design">
                  <span class="checkmark"></span>
                  Design graphique
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.photo" name="photo">
                  <span class="checkmark"></span>
                  Photographie / Vidéographie
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.copywriting" name="copywriting">
                  <span class="checkmark"></span>
                  Copywriting
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.global" name="global">
                  <span class="checkmark"></span>
                  Accompagnement global
                </label>
                
                <label class="service-checkbox">
                  <input type="checkbox" [(ngModel)]="formData.services.development" name="development">
                  <span class="checkmark"></span>
                  Développement d'application (web/mobile)
                </label>
              </div>
              
              <div class="select-wrapper budget-select">
                <select 
                  class="form-control"
                  [(ngModel)]="formData.budget"
                  name="budget">
                  <option value="" disabled selected>Budget</option>
                  <option value="500-1000">500 - 1000 EUR </option>
                  <option value="1000-2500">1000 - 2500 EUR</option>
                  <option value="2500-5000">2500 - 5000 EUR</option>
                  <option value="5000+">5000+ EUR</option>
                </select>
              </div>
              
              <div class="form-navigation">
                <button type="button" class="prev-button" (click)="previousStep()">
                  Précédent
                </button>
                <button 
                  type="button" 
                  class="suivant-button" 
                  (click)="nextStep()" 
                  [disabled]="!hasSelectedServices()">
                  Suivant
                </button>
              </div>
            </div>

            <!-- Step 3: Details -->
            <div *ngIf="currentStep === 3" class="form-step">
              <input 
                type="text" 
                class="form-control" 
                placeholder="Sujet"
                [(ngModel)]="formData.subject"
                name="subject"
                required>
              
              <textarea 
                class="form-control textarea" 
                placeholder="Donnez nous plus de détails sur votre projet"
                [(ngModel)]="formData.details"
                name="details"
                rows="6"></textarea>
              
              <label class="terms-checkbox">
                <input 
                  type="checkbox" 
                  [(ngModel)]="formData.acceptTerms" 
                  name="acceptTerms"
                  required>
                <span class="checkmark"></span>
                En cochant cette case, vous acceptez notre <span class="link-text">Politique de Confidentialité</span> et <span class="link-text">Conditions Générales d'Utilisation</span>.
              </label>
              
              <div class="form-navigation">
                <button type="button" class="prev-button" (click)="previousStep()">
                  Précédent
                </button>
                <button 
                  type="submit" 
                  class="suivant-button"
                  [disabled]="!formData.acceptTerms || !formData.subject || isSubmitting"
                  [class.button-loading]="isSubmitting">
                  <span *ngIf="!isSubmitting">Envoyer la demande</span>
                  <span *ngIf="isSubmitting" class="loading-spinner">Envoi en cours...</span>
                </button>
              </div>
            </div>
            
          </form>
          
          <!-- Success State - Show after form submission -->
          <div *ngIf="submissionSuccess" class="success-state">
            <div class="success-content">
              <div class="success-icon-large">✓</div>
              <h3>Merci pour votre demande!</h3>
              <p>Nous avons bien reçu votre demande de devis et nous vous contacterons dans les 24 heures.</p>
              <button type="button" class="suivant-button" (click)="resetForm()">
                Nouvelle demande
              </button>
            </div>
          </div>
          
        </div>
      </div>
      
    </div>
    
    <!-- Partners Section -->
    <div class="partners-content">
      <h2 class="section-title">Nos Partenaires</h2>
      <p class="section-description">
        Les meilleurs partenaires, les meilleurs outils, les meilleures plateformes, pour vous offrir le meilleur service.
      </p>
      
      <div class="partners-slider">
        <div class="partners-track">
          <div class="partner-item">
            <img src="assets/images/bb/ahrefs-logo.svg" alt="Ahrefs" />
          </div>
          <div class="partner-item">
            <img src="assets/images/bb/prestashop-logo.svg" alt="PrestaShop" />
          </div>
          <div class="partner-item">
            <img src="assets/images/bb/WordPress_logo_2.svg" alt="WordPress" />
          </div>
          <div class="partner-item">
            <img src="assets/images/bb/aws-p.svg" alt="AWS Partner Network" />
          </div>
          <div class="partner-item">
            <img src="assets/images/bb/meta-p.svg" alt="Meta Business Partner" />
          </div>
          <!-- Duplicate for infinite scroll -->
          <div class="partner-item">
            <img src="assets/images/bb/ahrefs-logo.svg" alt="Ahrefs" />
          </div>
          <div class="partner-item">
            <img src="assets/images/bb/prestashop-logo.svg" alt="PrestaShop" />
          </div>
          <div class="partner-item">
            <img src="assets/images/bb/WordPress_logo_2.svg" alt="WordPress" />
          </div>
          <div class="partner-item">
            <img src="assets/images/bb/aws-p.svg" alt="AWS Partner Network" />
          </div>
          <div class="partner-item">
            <img src="assets/images/bb/meta-p.svg" alt="Meta Business Partner" />
          </div>
          <div class="partner-item">
            <img src="assets/images/bb/gc-p.svg" alt="Google Cloud Partner" />
          </div>
        </div>
      </div>
      
      <!-- Navigation arrows -->
      <div class="partners-navigation">
        <button class="nav-arrow prev-arrow" (click)="slidePartners('prev')">
          <i>‹</i>
        </button>
        <button class="nav-arrow next-arrow" (click)="slidePartners('next')">
          <i>›</i>
        </button>
      </div>
    </div>
    
  </div>
</section>



<!-- Digital Alchemy Section HTML -->
<section class="digital-alchemy-section">
  <div class="container">
    <div class="digital-alchemy-content">
      
      <!-- Left Column - Logo -->
      <div class="digital-alchemy-left">
        <div class="digital-alchemy-logo">
          <img src="assets/images/Logo-5.png" alt="Digital Alchemy Logo" />
        </div>
      </div>
      
      <!-- Right Column - Content -->
      <div class="digital-alchemy-right">
        <h1>
          <span class="brand-name">Digital Alchemy</span>, Votre Partenaire De Création De Site Web 
        </h1>
        
        <p class="description">
          <span class="brand-name">Digital Alchemy</span>, agence marketing digital vous propose des stratégies adaptées à vos besoins pour propulser votre site en tête des résultats de recherche.
        </p>
        
        <ul class="services-list">
          <li>
            Améliorez votre visibilité SEO : avec un Référencement Naturel de Haute Qualité pour booster votre classement sur Google.
          </li>
          <li>
            <strong>Créez un site performant :</strong> grâce à un <span class="highlight">Tarif Développement Site Web</span> compétitif et des solutions optimisées.
          </li>
          <li>
            <strong>Lancez un business en ligne :</strong> avec une boutique bien référencée et un <span class="highlight">Dropshipping Optimisé</span>.
          </li>
          <li>
            <strong>Boostez vos conversions</strong> en appliquant des <span class="highlight">Types de Marketing</span> modernes et efficaces.
          </li>
          <li>
            <strong>Optimisez vos ventes :</strong> avec des stratégies de <span class="highlight">Marketing Commercial</span> adaptées pour maximiser votre ROI.
          </li>
        </ul>
        
        <button class="cta-button" type="button" routerLink="/devis">
          Je Demande Mon Devis Gratuit!
        </button>
      </div>
      
    </div>
  </div>
</section>




<!-- Portfolio Section - Add this to your rhillane.component.html -->
<!-- Portfolio Section - Add this to your rhillane.component.html -->

<!-- Portfolio Modal (Optional) -->




<!-- Updated Footer HTML -->
<footer class="footer-section">
  <div class="footer-container">
    
    <!-- Main Footer Content -->
    <div class="footer-content">
      
      <!-- Section 1: Company Logo & Description -->
      <div class="footer-company">
        <div class="company-logo">
          <img src="assets/images/logo-white.png" alt="Rhillane Logo" />
        </div>
        
        <p class="company-description">
          Digital Alchemy, votre partenaire de confiance pour la création de sites web . 
          Nous transformons vos idées en succès digital avec des solutions innovantes et performantes.
        </p>
        
        <!-- Social Media -->
        <div class="social-media-section">
          <ul style="display: flex; gap: 16px; list-style: none; padding: 0; margin: 0;">
            
            <!-- Facebook -->
            <li style="margin: 0;">
              <a href="https://www.facebook.com/people/Digital-alchemy/61565618420833" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Facebook page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #1877F2; fill: #1877F2;" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </li>
            
            <!-- Behance -->
            <li style="margin: 0;">
              <a href="https://www.behance.net/digitalalchemy2" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Behance page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #1769FF; fill: #1769FF;" viewBox="0 0 24 24">
                  <path d="M0 4.4804V19.243h7.1554c.6613 0 1.3078-.0832 1.9297-.248.6288-.1654 1.1905-.4203 1.6792-.7661.485-.3431.8784-.7804 1.1677-1.3081.2862-.5258.4294-1.1471.4294-1.8641 0-.8784-.2067-1.6309-.6172-2.2506-.4073-.6172-.9897-1.0907-1.7494-1.4161.6388-.3431 1.1139-.8141 1.4285-1.4143.3146-.6002.4719-1.2755.4719-2.0274 0-.7193-.1327-1.3487-.4-1.8888-.2668-.5402-.6343-1.0033-1.0995-1.3914-.4652-.3881-.9712-.6884-1.5186-.8999C8.8135 4.5932 8.2071 4.4804 7.5446 4.4804H0zM15.3486 6.9795h4.7992v1.2755h-4.7992V6.9795zM3.2695 6.9795h3.8893c.9451 0 1.6612.2262 2.1463.6787.4851.4525.7277 1.0632.7277 1.8321 0 .8374-.2768 1.4676-.8323 1.8888-.5555.4212-1.2925.6323-2.2091.6323H3.2695V6.9795zM15.3486 13.2363h4.7992v1.2755h-4.7992v-1.2755zM3.2695 14.2834h4.3172c.6927 0 1.2944.1327 1.8051.3976.5107.2649.9378.6154 1.2755 1.0519.3377.4365.5849.9378.741 1.5044.1561.5666.2342 1.1543.2342 1.7632 0 .7193-.1014 1.3487-.3043 1.8888-.2029.5401-.5107.9949-.9237 1.3648-.4131.3699-.9378.6507-1.5743.8409-.6365.1902-1.3858.2853-2.2477.2853H3.2695v-7.0969z"/>
                </svg>
              </a>
            </li>
            
            <!-- LinkedIn -->
            <li style="margin: 0;">
              <a href="https://www.linkedin.com/company/digital-alchemy-ma/" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our LinkedIn page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #0077B5; fill: #0077B5;" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </li>
            
            <!-- YouTube -->
            <li style="margin: 0;">
              <a href="https://www.youtube.com/@Digital_Alchemy_ma" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our YouTube page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #FF0000; fill: #FF0000;" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </li>
            
            <!-- Instagram -->
            <li style="margin: 0;">
              <a href="https://www.instagram.com/digital_alchemy_ma/" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Instagram page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #E1306C; fill: #E1306C;" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </li>
            
          </ul>
        </div>
      </div>
      
      <!-- Section 2: Contact Information -->
      <div class="footer-contact">
        <h3 class="footer-title">CONTACT</h3>
        
        <div class="contact-info">
          <div class="contact-item">
            <span>+212 690 459 525</span>
          </div>
          <div class="contact-item">
            <span>+33 6 66 07 64 55</span>
          </div>
          <div class="contact-item">
            <span>Digitalalchemyma&#64;gmail.com</span>
          </div>
          <div class="contact-item">
            <span>Contact&#64;digalchemy.com</span>
          </div>
        </div>
        
        <div class="office-locations">
          <div class="office-item">
            <h4>NOTRE BUREAU AU MAROC</h4>
            <p>Bd Dammam, Technopark Casablanca , Maroc .</p>
          </div>
        </div>
      </div>
      
      <!-- Section 3: Services Column -->
      <div class="footer-links">
        <h3 class="footer-title">NOS SERVICES</h3>
        <ul class="footer-list">
          <li><a routerLink="/web">Sites Web</a></li>
<li><a routerLink="/appweb">Application Web</a></li>
          <li><a routerLink="/publicite">Publicité en ligne</a></li>
          <li><a routerLink="/gestion">Gestion des réseaux sociaux</a></li>
          <li><a routerLink="/design">Design Graphique</a></li>
          <li><a routerLink="/agence">Agence SEO</a></li>
        </ul>
      </div>
      
      <!-- Section 4: Quick Links Column -->
      <div class="footer-links">
        <h3 class="footer-title">LIENS RAPIDES</h3>
        <ul class="footer-list">
          <li><a routerLink="/">Accueil</a></li>
          <li><a routerLink="/apropos">À propos</a></li>
          <li><a routerLink="/contact">Contact</a></li>
          <li><a routerLink="/cgu">Conditions Générales d'Utilisation</a></li>
          <li><a routerLink="/conf">Politique de Confidentialité</a></li>
        </ul>
      </div>
      
    </div>
    
    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <p class="copyright">
          © {{ currentYear }} Digital Alchemy. Tous droits réservés. | 
          <a routerLink="/cgu">Mentions légales</a> | 
          <a routerLink="/conf">Politique des cookies</a>
        </p>
        <div class="footer-bottom-links">
          <a routerLink="/contact">Support</a>
        </div>
      </div>
    </div>
    
  </div>
</footer>